import React, { useMemo, useState } from 'react';
import { Grid, IconButton, TextField } from '@material-ui/core';
import { Close as CloseIcon } from '@material-ui/icons';
import AddIcon from '@mui/icons-material/Add';
import { css } from '@emotion/react';
import { colors } from '@/styles';
import { PrimaryButton } from '@/styles/blocks';
import { Body1, Header1 } from '../blocks';
import CarrierBadges from './CarrierBadges';
import { pickableCarriers } from './utils';

const CarrierPicker = ({ options, mappings, onAdd, onClose, disabled }) => {
    const [search, setSearch] = useState('');
    const visible = useMemo(() => pickableCarriers(options, mappings, search), [options, mappings, search]);

    return (
        <Grid
            container
            direction="column"
            css={css`
                flex-wrap: nowrap;
                gap: 8px;
                padding: 12px;
                margin: 0 -16px;
                width: calc(100% + 32px);
                background: ${colors.greys[2]};
            `}
        >
            <Grid
                container
                css={css`
                    flex-wrap: nowrap;
                    gap: 6px;
                    align-items: center;
                `}
            >
                <TextField
                    autoFocus
                    fullWidth
                    size="small"
                    variant="outlined"
                    placeholder="Search Carriers"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    css={css`
                        .MuiInputBase-root {
                            background: ${colors.white.primary};
                        }
                    `}
                />
                <IconButton
                    size="small"
                    aria-label="close carrier search"
                    onClick={onClose}
                    css={css`
                        color: ${colors.white.primary};
                    `}
                >
                    <CloseIcon fontSize="small" />
                </IconButton>
            </Grid>
            <Grid
                container
                direction="column"
                css={css`
                    flex-wrap: nowrap;
                    gap: 8px;
                    max-height: 320px;
                    overflow-y: auto;
                `}
            >
                {visible.map((carrier) => (
                    <Grid
                        key={carrier.client_id}
                        container
                        direction="column"
                        css={css`
                            flex-wrap: nowrap;
                            gap: 6px;
                            padding: 10px 12px;
                            border-radius: 4px;
                            background: ${colors.white.primary};
                        `}
                    >
                        <Grid
                            container
                            css={css`
                                flex-wrap: nowrap;
                                align-items: center;
                                justify-content: space-between;
                                gap: 8px;
                            `}
                        >
                            <Header1
                                css={css`
                                    font-weight: 600;
                                    overflow: hidden;
                                    text-overflow: ellipsis;
                                    white-space: nowrap;
                                `}
                            >
                                {carrier.business_name}
                            </Header1>
                            <PrimaryButton
                                aria-label={`add ${carrier.business_name}`}
                                disabled={disabled}
                                onClick={() => onAdd(carrier)}
                                css={css`
                                    height: 26px;
                                    min-width: 0;
                                    padding: 0 10px;
                                `}
                            >
                                <span
                                    css={css`
                                        display: inline-flex;
                                        align-items: center;
                                        font-size: 13px;
                                    `}
                                >
                                    <AddIcon
                                        css={css`
                                            font-size: 16px;
                                        `}
                                    />
                                    Add
                                </span>
                            </PrimaryButton>
                        </Grid>
                        <CarrierBadges statuses={carrier.statuses} />
                    </Grid>
                ))}
                {!visible.length ? (
                    <Body1
                        css={css`
                            color: ${colors.white.primary};
                            padding: 8px 4px;
                        `}
                    >
                        {search ? `No carriers matching "${search}"` : 'No more carriers to add'}
                    </Body1>
                ) : null}
            </Grid>
        </Grid>
    );
};

export default CarrierPicker;
